import React, {useState, useEffect} from 'react'
import BookVendorAppointment from './BookVendorAppointment'
import {VendorServiceTypeDogwalking} from '../../Services/ServicesConstants'
import Routes from '../../../constants/RouteConstants'
import {FormComponentPropTypes} from '../onboardingTypes'

function BookDogWalk(props) {
  return <BookVendorAppointment {...props} serviceType={VendorServiceTypeDogwalking} viewSingleRoute={Routes.DOGWALKING_VIEW_SINGLE} />
}

export default BookDogWalk

BookDogWalk.propTypes = FormComponentPropTypes
